export default __webpack_public_path__ + "static/media/NoPathCopie.abe24c21.png";